import { render } from "./SelectableItem.vue?vue&type=template&id=89965120&ts=true"
import script from "./SelectableItem.vue?vue&type=script&lang=ts"
export * from "./SelectableItem.vue?vue&type=script&lang=ts"

import "./SelectableItem.vue?vue&type=style&index=0&id=89965120&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__